var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',{attrs:{"id":"list_menu"}},[_c('router-link',{attrs:{"to":"/admin/uploads"}},[_vm._v("Загрузки ADIF")]),_c('router-link',{attrs:{"to":"/admin/qsl"}},[_vm._v("QSL карточки")]),_c('router-link',{attrs:{"to":"/admin/callsigns"}},[_vm._v("Позывные")])],1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }